import { IoIosSend } from 'react-icons/io'

import { Box, ModalCloseButton, ModalHeader, Spacer } from '@chakra-ui/react'

interface FeedbackModalHeaderIProps {
  title: string
}

export const CreateUserFeedbackModalHeader = ({
  title,
}: FeedbackModalHeaderIProps) => {
  return (
    <ModalHeader>
      <Box alignItems='center' display='flex'>
        <Box display='grid' placeItems='center'>
          <IoIosSend size='32px' />
        </Box>
        <Box
          color='#353849'
          fontSize='26px'
          fontWeight='extrabold'
          letterSpacing='-0.4px'
          ml={2}
        >
          {title}
        </Box>
        <Spacer />
        <ModalCloseButton color='#000' opacity={0.4} position='initial' />
      </Box>
    </ModalHeader>
  )
}
